export enum ProjectChangesStatus {
  CHANGE_STATUS_CREATED = 'created',
  CHANGE_STATUS_EDITED = 'edited',
  CHANGE_STATUS_SHARED = 'shared',
  CHANGE_STATUS_ACCEPTED = 'accepted',
  CHANGE_STATUS_REJECTED = 'rejected',
  CHANGE_STATUS_SETTLED = 'settled',
  CHANGE_STATUS_AUTO_ACCEPT = 'auto-accept',
}
